"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cox_survival_algorithm_1 = require("../algorithm/regression-algorithm/cox-survival-algorithm/cox-survival-algorithm");
class CoxFactory {
    static extendCox(cox, additionalProperties) {
        return Object.setPrototypeOf(Object.assign({}, cox, additionalProperties), cox_survival_algorithm_1.CoxSurvivalAlgorithm.prototype);
    }
}
exports.CoxFactory = CoxFactory;
//# sourceMappingURL=cox-survival-algoritm.js.map